//スムーズスクロール

$(function(){
  $('a[href^="#"]').click(function(){
    var speed = 500;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;
    $("html, body").animate({scrollTop:position}, speed, "swing");
    return false;
  });
});

// スクロールでpageTOP
$(function() {
    var showFlag = false;
    var topBtn = $('.footer__pagetop');
    topBtn.css('bottom', '-200px');
    var showFlag = false;
    //スクロールが100に達したらボタン表示
    $(window).scroll(function () {
        if ($(this).scrollTop() > 120) {
            if (showFlag == false) {
                showFlag = true;
                topBtn.css('display', 'block');
                topBtn.stop().animate({'bottom' : '10px'}, 200);
            }
        } else {
            if (showFlag) {
                showFlag = false;
                topBtn.css('display', 'none');
                topBtn.stop().animate({'bottom' : '-200px'}, 200);
            }
        }
    });
    //スクロールしてトップ
    topBtn.click(function () {
        $('body,html').animate({
            scrollTop: 0
        }, 500);
        return false;
    });
});


// スクロールで要素が表示された時にclassを付与する
function add_class_in_scrolling(target) {
    var winScroll = $(window).scrollTop();
    var winHeight = $(window).height();
    var scrollPos = winScroll + winHeight;

    if(target.offset().top < scrollPos) {
        target.addClass('on');
    }
}

//スクロール連動アニメーション
$(window).on('load scroll', function() {

  if($('.contents--campus').length) {
    add_class_in_scrolling($('.campus__map'));
  } else if($('.contents--courses').length) {
    add_class_in_scrolling($('.courses__learn'));
    add_class_in_scrolling($('.courses__curriculum'));
    add_class_in_scrolling($('.courses__qualification'));
    add_class_in_scrolling($('.courses__employment'));
  }else if($('.contents--highschool').length) {
    add_class_in_scrolling($('.highschool__purpose'));
    add_class_in_scrolling($('.highschool__subject'));
    add_class_in_scrolling($('.highschool__target'));
  }else if($('.contents--support').length) {
    add_class_in_scrolling($('.support__attendance'));
    add_class_in_scrolling($('.support__businesses'));
    add_class_in_scrolling($('.support__contact'));
  }

});



// WEBPACK FOOTER //
// ./assets/js/app.js